<template>
    <div class="">
      <!-- Content Header (Page header) -->
      <div class="">
        <!-- Main content -->
        <section class="content" id="clubDirectory">
          <div class="container-fluid">
            <!-- Main row -->
            <div class="row">
              <section class="col-lg-12 connectedSortable table-area mt-3 pr-0 pl-0 mb-3">
                <div class="card">
                  <div class="card-body table-responsive table-head">
                    <div class="row bor-bot pb-2">
                      <div class="col-md-8 pl-0">
                        <div class="d-flex align-items-center pt-2 pb-2">
                          <a target="_blank" href="https://www.usawaterski.org/" class="mr-3">
                            <img src="/dist/img/waterski_logo.png" style="max-width:100px;" alt="wtc-banner">
                          </a>
                          <h1 style="font-size: 32px !important;" class="display-3 m-0 text-dark pt-2 pb-2">{{ 'Affiliated Club Directory' }}</h1>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="text-right pb-3">
                          <ol class="breadcrumb float-sm-right">
                            <!-- <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item"><Breadcrumbs /></li> -->
                            <li class="breadcrumb-item">
                                <span style="display: flex; align-items: center; gap: 20px;">
                                    <span style="display: flex; align-items: center; gap: 5px; color:#b23b2c;">
                                        <i class="fa fa-phone"></i>
                                        863-324-4341
                                    </span>

                                    <span style="display: flex; align-items: center; gap: 5px; color:#b23b2c;">
                                        <i class="fa fa-envelope"></i>
                                        <a href="mailto:memberservices@usawaterski.org">memberservices@usawaterski.org</a>
                                    </span>
                                </span>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                     <!-- Filter and Reset Buttons -->
                     <div class="card shadow-sm p-3 mb-3">

                        <p class="mb-3">
                            <strong class="text-primary">Note:</strong>
                            <span class="text-muted">
                                Press Ctrl+click for multiple selection filters
                            </span>
                        </p>

                        <form @submit.prevent="advancedSearch()">

                            <div class="row align-items-end">

                                <div class="col-md-3">
                                    <label class="form-label">Club Type</label>
                                    <Select2
                                        v-model="searchForm.club_type"
                                        :options="getClubTypes"
                                        :settings="{ multiple: true, placeholder: 'All', dropdownAutoClose: true, closeOnSelect: true, closeOnBlur: true}"
                                    />
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">Region</label>
                                    <Select2
                                        v-model="searchForm.region_name"
                                        :options="regionsListSelect2"
                                        :settings="{ multiple: true, placeholder: 'All', dropdownAutoClose: true, closeOnSelect: true, closeOnBlur: true}"
                                    />
                                </div>

                                <div class="col-md-3">
                                    <label class="form-label">State</label>
                                    <Select2
                                        v-model="searchForm.site_state"
                                        :options="listOfStates.map(s => ({ id: s.state_code, text: s.state }))"
                                        :settings="{ multiple: true, placeholder: 'All', dropdownAutoClose: true, closeOnSelect: false, closeOnBlur: true}"
                                    />
                                </div>

                                <div class="col-md-3 d-flex align-items-end mt-3 mt-md-0" style="gap: 10px;">

                                  <b-button type="submit" variant="primary" class="btn-blue btn-equal">
                                    <i class="fas fa-search-plus"></i> Search
                                  </b-button>

                                  <b-button type="button" variant="secondary" class="btn-equal ms-2" @click="refreshList" v-if="filtersApplied">
                                    <i class="fas fa-redo"></i> Reset
                                  </b-button>

                                </div>

                                <p class="mb-3 mt-3">
                                    <strong class="text-primary">Note:</strong>
                                    <span class="text-muted">
                                      We would like your feedback about this search feature. Please send comments to <a href="mailto:memberservices@usawaterski.org" class="text-decoration-underline">memberservices@usawaterski.org</a>.
                                    </span>
                                </p>


                                <div class="col-12 text-center text-danger">
                                    {{ errors.not_found }}
                                </div>
                            </div>
                        </form>
                      </div>
                    <!-- end -->
                    <div class="table-responsive mt-4">
                      <!-- <div class="data-tablebutn pb-3">
                        
                        <b-button class="btn-primary btn-darkblue btn mr-1" :class="{ 'filter-applied': filtersApplied }" v-b-modal.modal-club-report>
                          <i class="fas fa-sliders-h"></i> Filters
                        </b-button>
                        <b-button class="btn-primary btn-darkblue btn" @click="refreshList" v-if="filtersApplied">
                          <i class="fas fa-redo"></i> Reset
                        </b-button>
                      </div> -->
                      <div class="text-center mb-3">
                          <span class="text-muted">Click on a column heading to sort</span>
                      </div>
                      <table class="table table-sm table-bordered table-hover" id="list_table">
                        <thead class="thead-dark">
                          <tr>
                            <th class="all">State</th>
                            <th class="all">City</th>
                            <th class="all">Site</th>
                            <th class="all">Club</th>
                            <th class="all">Club Type</th>
                            <th class="all">Club Contact</th>
                            <th class="all">Club Website</th>
                            <th class="all">Email</th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Data will be placed here -->
                          <tr>
                            <td colspan="9"> </td>
                          </tr>
                          <tr>
                            <td colspan="9"> </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="text-center mt-4 mb-3" style="font-size: 14px; line-height: 1.4;">
                        <div><strong>USA Water Ski &amp; Wake Sports</strong></div>
                        <div>2701 Lake Myrtle Park Road, Auburndale, FL 33823</div>
                        <div>(ph) 863-324-4341 &nbsp; (fax) 863-325-8259</div>
                        <div>Monday - Friday &nbsp; 8:30 a.m. - 5 p.m. EST</div>
                        <div class="mt-2">&copy; 2025 USA Water Ski &amp; Wake Sports</div>
                    </div>
  
                    <!-- <b-modal id="modal-club-report" v-bind:hide-footer="true" ref="modal-club-report" size="xl" title="Advanced Search">
                      <p style="margin-top: -20px;margin-bottom: 30px ">
                        <strong class="text-primary">Note:</strong> <span class="text-muted">Press Ctrl+click for multiple selection filters</span>
                      </p>
                      <form ref="form" method="post" @submit.prevent="advancedSearch()">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="club_type" class="form-label">Club Type</label><br>
                              <Select2
                                v-model="searchForm.club_type"
                                name="club_type"
                                id="club_type"
                                :options="getClubTypes"
                                :settings="{ multiple: true, placeholder: 'Click to select one or multiple'}"
                              />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="form-label">Region</label>
                              <Select2
                                v-model="searchForm.region_name"
                                name="region_name"
                                id="region_name"
                                :options="regionsListSelect2"
                                :settings="{ multiple: true, placeholder: 'All Regions'}"
                              />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="form-label">State</label>
                              <select id="site_state" class="form-control" v-model="searchForm.site_state" name="searchForm.site_state">
                                <option value="">Select</option>
                                <option v-for="listOfState in listOfStates" :key="listOfState.state_code" :value="listOfState.state_code">{{ listOfState.state }}</option>
                              </select>
                            </div>
                          </div>
                         
                          <div class="col-md-12 modal-searchbtn text-center">
                            <div class="form-group d-flex justify-content-center gap-2">
                              <button type="submit" class="btn btn-primary btn-blue">{{ button.SearchButton }}</button>
                            </div>
                            <div class="text-sm text-danger">{{ errors.not_found }}</div>
                          </div>
                        </div>
                      </form>
                    </b-modal> -->

                    <b-modal id="modal-send-email" ref="modal-send-email" title="USA Water Ski Member Contact Send Message" v-bind:hide-footer="true" :lazy="false">
                      <template #modal-title>
                        <div class="d-flex align-items-center">
                          <a target="_blank" href="https://www.usawaterski.org/" class="mr-2">
                            <img src="/dist/img/waterski_logo.png" style="max-width:100px;" alt="wtc-banner">
                          </a>
                          <span>USA Water Ski Member Contact Send Message</span>
                        </div>
                      </template>
                      <form @submit.prevent="sendEmail">
                        <div class="form-group">
                          <label>Your Name:</label>
                          <input type="text" v-model="emailForm.your_name" class="form-control" required>
                        </div>
                        <div class="form-group">
                          <label>Your Email Address:</label>
                          <input type="email" v-model="emailForm.your_email" class="form-control" required>
                        </div>
                        <div class="form-group">
                          <label>Subject:</label>
                          <input type="text" v-model="emailForm.subject" class="form-control" required>
                        </div>
                        <div class="form-group">
                          <label>Message:</label>
                          <textarea v-model="emailForm.message" class="form-control" rows="4" required></textarea>
                        </div>

                        <div class="form-group text-right">
                          <b-button type="submit" variant="primary" :disabled="sendingEmail">
                            <span v-if="sendingEmail">
                              <b-spinner small class="mr-1" type="border" /> Sending...
                            </span>
                            <span v-else>
                              Send Email
                            </span>
                          </b-button>
                        </div>

                        <div class="form-group text-center">
                          <p class="font-weight-bold">
                            This system is for the express use of USA Waterski Members and directors of sanctioned events. Sending unsolicited messages to our members is strictly forbidden!
                          </p>
                        </div>

                        <hr>
                        <div>
                          <strong>Individuals requested for contact:</strong> {{ emailForm.contact_name }}
                        </div>
                        <hr>

                      <div class="text-center mt-4 small text-muted">
                        <div>USA Water Ski & Wake Sports</div>
                        <div>2701 Lake Myrtle Park Road, Auburndale, FL 33823</div>
                        <div>(ph) 863-324-4341 &nbsp; | &nbsp; (fax) 863-325-8259</div>
                        <div>Monday - Friday 8:30 a.m. - 5 p.m. EST</div>
                        <div class="mt-2">&copy; Copyright 2025 USA Water Ski & Wake Sports</div>
                      </div>
                      </form>
                    </b-modal>

                  </div>
                </div>
              </section>
            </div>
            <!-- /.row (main row) -->
          </div><!-- /.container-fluid -->
        </section>
      </div>
      <!-- /.content -->
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  import "datatables.net-dt/js/dataTables.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";
  import moment from 'moment';
  import $ from "jquery";
  import axios from 'axios';

  let cachedData = {};
  
  export default {
    components: {  },
    data() {
      return {
        searchValue: '',
        exportProgress: false,
        filtersApplied: false,
        loaded: false,
        perPage: 10,
        currentPage: 1,
        fields: [
          { key: 'team_name', label: 'Team Name', sortable: true },
          { key: 'type', label: 'Type', sortable: true },
          { key: 'first_name', label: 'First Name', sortable: true },
          { key: 'last_name', label: 'Last Name', sortable: true },
          { key: 'updated_at', label: 'Registered', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'transaction_id', sortable: true },
          { key: 'actions', sortable: false },
        ],
        items: [],
        viewEntryOptions: [
          { value: 100, text: '100' },
          { value: 150, text: '150' },
          { value: 200, text: '200' },
          { value: 250, text: '250' },
          { value: 300, text: '300' },
        ],
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        couponcode: [],
        searchForm: {
          club_type: '',
          region_name: '',
          site_state: '',
          state_code: '',
        },
        button: {
          SearchButton: 'Search'
        },
        errors: {},
        table: {},
        clubTypes: [],
        membershipData: [],
        teamLeague: [],
        disciplines: [],
        seasons: [],
        disciplines_list: [],
        ageDivisionOPt: [
          { "id": "4", "text": "12U" },
          { "id": "5", "text": "10U" }
        ],
        emailForm: {
          to: '',
          contact_name: '',
          your_name: '',
          your_email: '',
          subject: '',
          message: ''
        },
        sendingEmail: false
      };
    },
    methods: {
      formatDate(value) {
        var date = moment(value, "YYYY-MM-DD hh:mm:ss");
        if (date.isValid()) {
          return date.format('MM/DD/YYYY');
        } else {
          return 'N/A';
        }
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      viewRow(item, index, button) {
        this.infoModal.title = item.first_name + ' ' + item.last_name;
        this.infoModal.content = item;
        this.$root.$emit('bv::show::modal', this.infoModal.id, button);
      },
      resetInfoModal() {
        this.infoModal.title = '';
        this.infoModal.content = '';
      },
      editRow(id) {
        console.log('Editing row...' + id);
      },
      deleteRow(id) {
        console.log('Deleting row...' + id);
      },
      loadData: function() {
        axios.post(process.env.VUE_APP_URL + 'api/public/reports/registration/Club', this.searchForm)
          .then((response) => {
            cachedData = response.data.registrations;
            this.items = cachedData;
            this.loaded = true;
            this.button.SearchButton = 'Search';
            if (this.loaded == true) {
              this.$refs['modal-club-report'].hide();
            }
          })
          .catch(error => {
            this.errors = error.response.data;
          });
      },
      Search(event) {
        this.term = this.$route.query.term;
        if (this.term == '') {
          return true;
        }
        this.searchValue = this.$route.query.term;
        if (this.searchValue !== undefined) {
          this.searchValue = $("#globalSearch").val();
          const dataTable = $("#list_table").DataTable();
          dataTable.search(this.searchValue).draw();
        }
      },
      advancedSearch() {
        $('.select2-hidden-accessible').select2('close');
        this.button.SearchButton = 'Searching...';
        this.loaded = false;
        this.table.draw();
        this.filtersApplied = true;
        this.$refs['modal-club-report'].hide();
        this.button.SearchButton = 'Search';
      },
      
      refreshList(event){
            this.searchForm = {
                club_type: '',
                region_name: '',
                site_state: '',
                state_code: '',      
            };
            this.table.ajax.reload();
            this.filtersApplied = false;
          },
      getMembership() {
        axios.get(this.basePath + "api/getMemberships/club")
          .then((response) => {
            this.membershipData = response.data.data;
          })
          .catch(error => {
            console.log("error getting Membership info");
          });
      },
      getLeague() {
        axios.get(this.basePath + "api/public/league")
          .then(response => {
            this.teamLeague = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
      getTeam() {
        let leagueId = this.searchForm.league;
        let teams = [];
        this.teamLeague.forEach(league => {
          if (this.searchForm.league == league.id) {
            teams = league.team;
          }
        });
        this.leagueTeam = [];
        teams.forEach(code => {
          if (this.searchForm.age_division == code.age_division) {
            this.leagueTeam.push({ id: code.id, text: code.name });
          }
        });
      },
      getSeason() {
        axios.get(this.basePath + 'api/public/get_season')
          .then((res) => {
            this.seasons = res.data.data;
          })
          .catch((error) => {
            console.log('Error:' + error);
            return false;
          });
      },
      sendEmail() {
        this.sendingEmail = true; 
        const payload = {
          to: this.emailForm.to,
          your_name: this.emailForm.your_name,
          your_email: this.emailForm.your_email,
          subject: this.emailForm.subject,
          message: this.emailForm.message,
          contact_name: this.emailForm.contact_name
        };

        axios.post(process.env.VUE_APP_URL + 'api/send-email-to-contact', payload, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(() => {
            this.$refs['modal-send-email'].hide();
            this.$bvToast.toast('Email sent successfully.', { variant: 'success', solid: true });
            this.emailForm = {
                to: '',
                your_name: '',
                your_email: '',
                subject: '',
                message: '',
                contact_name: ''
              };
          })
          .catch(() => {
            this.$bvToast.toast('Email failed to send.', { variant: 'danger', solid: true });
          })
          .finally(() => {
            this.sendingEmail = false; // re-enable button
          });
      }

    },
    mounted() {
      this.getClubType();
      this.getMembershipStatus();
      this.getMembership();
      if (this.subdomain === 'waterski') {
        this.getRegions();
      }
      var self = this;
      this.table = $("#list_table").DataTable({
        sDom: "lfrtip",
        processing: true,
        serverSide: true,
        pageLength: 100,
        bFilter: true,
        ajax: {
          url: process.env.VUE_APP_URL + "api/public/reports/registration/Club",
          type: 'post',
          data: function(d) {
            d.team_name = $('#club_name').val() || self.searchForm.club_name;
            d.team_type = $('#club_type').val() || self.searchForm.club_type;
            d.region_name = $('#region_name').val() || self.searchForm.region_name;
            const siteState = $('#site_state').val() || self.searchForm.site_state;
            if (siteState) {
              d.columns[0].search.value = siteState;
            }
            d.state_code = $('#state_code').val() || self.searchForm.state_code;
          }
        },
        columns: [
          { data: "team_state_code", name: "team.state_code", orderable: true, render: (data) => { return data || "N/A" } },
          { data: "team_city", name: "team.city", orderable: true, render: (data) => { return data || "N/A" } },
          { data: "team_site", name: "team_site", render: (data) => { return data || "N/A" } },
          { data: 'team_name', name: "team.name", render: value => value || 'N/A' },
          { data: 'team_type', name: 'team.type', render: (data, type, row, meta) => { return (row.team && row.team.club_type != undefined) ? row.team.club_type : (data || 'N/A'); } },
          { data: "tc_full_name", name: "tc_full_name", render: (data) => data || 'N/A' },
          {
            data: "team_website",
            name: "team.website",
            orderable: true,
            render: function (data) {
              if (data && data !== "N/A") {
                const url = data.startsWith('http://') || data.startsWith('https://')
                  ? data
                  : `https://${data}`;
                return `<a href="${url}" target="_blank" class="btn btn-sm btn-outline-primary">Website</a>`;
              } else {
                return "N/A";
              }
            }
          },
          {
            data: "tc_email",
            name: "tc_email",
            orderable: false,
            render: function (data, type, row) {
              if (!data) return "N/A";
              return `
                <button class="btn btn-sm btn-outline-success send-email-btn"
                        data-email="${data}"
                        data-name="${row.tc_full_name || ''}">
                  Send Email
                </button>`;
            }
          }
        ],
        order: [[0, "asc"], [3, "asc"]],
      });
      this.Search();
      $('#list_table tbody').on('click', '.send-email-btn', function () {
        const email = $(this).data('email');
        const name = $(this).data('name');

        self.emailForm.to = email;
        self.emailForm.contact_name = name;
        self.$refs['modal-send-email'].show();
      });
      $(document).on('click', function(e) {
        if (!$(e.target).closest('.select2-container').length) {
          $('.select2-hidden-accessible').select2('close');
        }
      });
    },
    computed: {
      rows() {
        return this.items.length;
      },
      searchTerm() {
        return this.$route.query.term;
      },
      getClubTypes: function() {
        let types = [];
        if (this.subdomain === "shooting") types = this.clubTypes;
        else {
          let keys = Object.keys(this.clubType);
          if (keys.length) {
            types = keys.map(key => {
              return { id: key, text: this.clubType[key] };
            });
          }
        }
        return types;
      },
      regionsListSelect2() {
        var keys = Object.keys(this.regionsList);
        return keys.map(item => {
          return { id: this.regionsList[item].code, text: this.regionsList[item].name };
        });
      },
    },
    watch: {
      searchTerm(newValue) {
        if (newValue !== '') {
          this.Search();
        }
      }
    }
  };
  </script>

  <style >
  #clubDirectory .data-tablebutn {
    top: 130px !important;
  }

  .btn-equal {
    height: 40px !important;     
    padding: 0 24px !important;           
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px;                          
    font-size: 15px;
    font-weight: 500;
    border-radius: 6px;                
  }

  .btn-equal i {
      font-size: 16px;
  }
  </style>